'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AddRecipientField = require('components/Recipients/AddRecipientField/AddRecipientField');

var _AddRecipientField2 = _interopRequireDefault(_AddRecipientField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddRecipientRow = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AddRecipientRow, _PureComponent);

  function AddRecipientRow() {
    (0, _classCallCheck3.default)(this, AddRecipientRow);
    return (0, _possibleConstructorReturn3.default)(this, (AddRecipientRow.__proto__ || (0, _getPrototypeOf2.default)(AddRecipientRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddRecipientRow, [{
    key: 'render',
    value: function render() {
      var t = this.context.t;
      var _props = this.props,
          formRowClassName = _props.formRowClassName,
          hintClassName = _props.hintClassName,
          projectId = _props.projectId,
          onAddGroup = _props.onAddGroup,
          withTags = _props.withTags,
          hideGroups = _props.hideGroups,
          hintText = _props.hintText,
          required = _props.required;


      return _react2.default.createElement(
        'div',
        { className: formRowClassName },
        _react2.default.createElement(
          'div',
          { className: hintClassName },
          hintText || t('Email or group') + '*'
        ),
        _react2.default.createElement(_AddRecipientField2.default, {
          projectId: projectId,
          onAddGroup: onAddGroup,
          hideGroups: hideGroups,
          withTags: withTags,
          required: required
        })
      );
    }
  }]);
  return AddRecipientRow;
}(_react.PureComponent), _class.propTypes = {
  formRowClassName: _propTypes2.default.string,
  hideGroups: _propTypes2.default.bool,
  hintClassName: _propTypes2.default.string,
  hintText: _propTypes2.default.string,
  onAddGroup: _propTypes2.default.func,
  projectId: _propTypes2.default.number,
  required: _propTypes2.default.bool,
  withTags: _propTypes2.default.bool
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  formRowClassName: 'formRow simple',
  hintClassName: 'colorDark',
  withTags: false
}, _temp);
exports.default = AddRecipientRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/AddRecipientRow/AddRecipientRow.js
// module id = 844
// module chunks = 1